/**
 * Ryan O'Dowd
 * 2025-06-10
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Badge as PaperBadge,
} from 'react-native-paper';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const Badge = (_p: BadgeProps & React.ComponentProps<typeof PaperBadge>) => {
  const props = {
    ...defaultProps,
    ..._p,
  };

  const styles = hooks.useStyles(getStyles);

  if (!props.visible) {
    return null;
  }

  const badgeColor = props.color || styles.colors.badge;
  let textColor = styles.colors.white;
  if ([styles.colors.accent, styles.colors.complete].includes(badgeColor)) {
    textColor = styles.colors.primaryExtraDark;
  }

  return (
    <PaperBadge
      {...props}
      size={styles.globalScale * (props.size || 16)}
      style={[styles.container(props.top, props.right), props.style]}
      theme={{
        colors: {
          error: badgeColor,
          onError: textColor,
        },
      }}
    >
      {props.children}
    </PaperBadge>
  );
};

class BadgeProps {
  visible?: boolean = true;
  size?: number = 16;
  color?: string; // @TODO: default to badge
  top?: number = 0;
  right?: number = 0;
};
const defaultProps = new BadgeProps();

Badge.displayName = 'Badge';
export default Badge;
